module.exports = __webpack_public_path__ + "static/media/gallery3.29756b9d.jpg";